<template>
  <div class="course_train_set">
    <div class="course_train_set_head">
      <div class="ct goback" @click="goback"><span class="el-icon-arrow-left " ></span>返回</div>
      <span class="ct">{{courseName}}</span>
      <span>
        <div class="login-user">
          <el-dropdown @command="handleCommand" :show-timeout="0">
            <div class="user-name el-dropdown-link">
                <div class="imgBox">
                  <img src="../../../static/images/hed0.png">
                </div>
                <div class="login-name">{{userName}}</div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="a">教务中心</el-dropdown-item> -->
              <!-- <el-dropdown-item command="b">个人中心</el-dropdown-item> -->
              <el-dropdown-item command="d">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </span>
    </div>
    <div class="course_train_set_bottom">
      <div class="course_train_set_tree">
        <new-sidebar
          ref="zlSidebar"
          @setStatus="setStatus"
          @clearCatalogName="clearCatalogName"
          :courseId="courseId"
          :subjectId="subjectId"
          :newName="'实操'"
          @openAddResoures="openAddResoures"
          @emptyCatalogue="emptyCatalogue"
          @handleTreeNodeClick="handleTreeNodeClick"
        ></new-sidebar>
      </div>
      <div class="course_train_set_content" v-loading="zl_loading">
          <div class="add_resources_operation" v-if="status != 3">
            <div class="catalog_name">{{catalogName}}</div>
            <span>
              <span class="zl_button zl_blueButton" v-if="status === 1" type="primary" size="mini" @click="status = 2">添加</span>
              <span class="zl_button zl_whiteButton" v-if="status === 2" type="primary" size="mini" @click="resources.length>0?status = 3:status = 4">取消</span>
              <span class="zl_button zl_blueButton"  v-if="status === 2" type="primary" @click="handleSaveTrain" plain size="mini">保存</span>
            </span>
          </div>
          <div class="btn_wrap" v-if="status === 1">
            <span class="zl_button zl_blueButton" plain size="mini" icon="el-icon-delete" @click.native.prevent="deleteAll">删除</span>
          </div>
        <!-- 内容展示 -->
        <transition name="el-zoom-in-center" v-if="status === 1">
          <div class="course_train_set_2">
            <el-table
              :data="resources"
              stripe
              height="100%"
              :cell-style="{ textAlign: 'left' , border: 'none'}"
              :header-cell-style="{ textAlign: 'left' }"
              @selection-change="handleSelectionChange"
            >
             <el-table-column
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column prop="name" label="标题">
                <template slot-scope="scope">
                  {{ scope.row.name ? scope.row.name : scope.row.tagName+  scope.row.id}}
                </template>
              </el-table-column>
              <el-table-column prop="difficulty" label="难度" width="150">
                <template slot-scope="scope">
                  {{ scope.row.difficulty == 1 ? '简单' : scope.row.difficulty == 2 ? '中等' : scope.row.difficulty == 3 ? '困难' : '' }}
                </template>
              </el-table-column>
              <el-table-column prop="score" label="建议分数" width="150"></el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="text"
                    @click.native.prevent="showRow(scope.row,scope.$index)"
                  >
                    预览
                  </el-button>
                  <el-button
                    @click.native.prevent="deleteRow(scope.row)"
                    size="mini"
                    type="text"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
              <div slot="empty" class="empty_material">
                <p>暂无试题</p>
              </div>
            </el-table>
          </div>
        </transition>
        <transition name="el-zoom-in-center" v-else-if="status === 2">
          <div class="course_train_set_3">
           <div :class="showTrigonActive?'tag_wrap trigonActive':'tag_wrap'">
             <el-tag
              disable-transitions
               v-for="tag in selectResourse"
               :key="tag.id"
               closable
               @close="closeTag(tag)"
               :type="tag.id+''">
               <template v-if="tag.name && tag.name!=''">{{ tag.name}}</template>
               <template v-else-if="tag.taskName && tag.taskName!=''">{{ tag.taskName}}</template>
                <template v-else-if="tag.content && tag.content!= ''">
                  <template v-if="$delHtmlTag.delHtmlTag(tag.content).substring(0,10).length>=10">
                    {{$delHtmlTag.delHtmlTag(tag.content).substring(0,10) + '...'}}
                  </template>
                  <template v-else>
                    {{$delHtmlTag.delHtmlTag(tag.content).substring(0,10)}}
                  </template>
                </template>
                <template v-else-if="tag.questionContent">
                  <template v-if="$delHtmlTag.delHtmlTag(tag.questionContent).substring(0,10).length>=10">
                    {{$delHtmlTag.delHtmlTag(tag.questionContent).substring(0,10) + '...'}}
                  </template>
                  <template v-else>
                    {{$delHtmlTag.delHtmlTag(tag.questionContent).substring(0,10)}}
                  </template>
                </template>
             </el-tag>
             <div class="trigon"  @click="showTrigonActive=!showTrigonActive"></div>
           </div>
           <div class="qst_wrap">
             <add-question
               ref="addQuestion"
               :qsType="2"
               :selectResourse="selectResourse"
               isShort
               @removeCheck="removeCheck"
               @getQuestionList="getQuestionList"
               :checkList="presentList"
               resourcesFrom="1"
               :courseId="courseId"
               checkout
               course
               @selectChange="selectChange"
               :subjectId="subjectId"
             ></add-question>
           </div>
          </div>
        </transition>
        <transition v-else-if="status === 3">
          <div class="show_content">
            <div class="show_left">
              <div class="add_resources_operation" >
                <div v-if="status ===3"></div>
                <div class="question_title">
                  {{catalogName}}
                </div>
                <div v-if="status ===3"></div>
              </div>
              <div class="cont ">
                <div class="add_resources_operation" style="background: #fff">
                  <div class="catalog_name" v-html="checkCataObj.name ? checkCataObj.name :($delHtmlTag.delHtmlTag(checkCataObj.content).length>40?$delHtmlTag.delHtmlTag(checkCataObj.content).substring(0,40)+'...':$delHtmlTag.delHtmlTag(checkCataObj.content))"></div>
                </div>
                <div class="cont_inner  editorShowArea ql-editor" v-html="checkCataObj.content">
                </div>
              </div>
            </div>
            <div class="show_right">
              <div class="show_title">
                <div>共计<span style="color:rgba(24, 144, 255, 1);margin: 0 3px;">{{resources.length>0?resources.length:''}}</span>个任务</div>
                <div style="display:flex;align-items:center;jusitify-content:center;color:rgba(24, 144, 255, 1);cursor:pointer; "  @click="edit">
                  <i class="el-icon-edit-outline" style="margin-right: 3px;"></i>
                  <div style="color:rgba(24, 144, 255, 1)">编辑</div>
                </div>

              </div>
                <draggable
                  class="syllable_ul"
                  element="ul"
                  :list="resources"
                  animation="500"
                  :no-transition-on-drag="true"
                  @change="change"
                  @start="start"
                  @end="end"
                  :move="move"
                >
                  <transition-group type="transition"  :name="!drag? 'syll_li' : null" :css="true">
                    <li @click="getCheckInfo(index)" v-for="(item,index ) in resources" :class="index==checkCataIndex?'active':''" :key="item.id">
                      <div class="syllable_img"></div>
                      <div class="title">任务{{index+1}}</div>
                      <div class="cont editorShowArea ql-editor" v-html="item.name ? item.name :$delHtmlTag.delHtmlTag(item.content)"></div>
                    </li>
                  </transition-group>
                </draggable>
            </div>
          </div>
        </transition>
        <!-- 首次进来展示内容 -->
        <transition name="el-zoom-in-center" v-else>
          <div class="course_train_set_0">
            <div class="course_train_set_c">
              <img style=" width:187px;height:159px;margin-bottom: 20px" src="../../../src/assets/image/sources/table_no_data.png" alt="">
              <p style="text-align: center" v-if="status === 0">一级目录下不能编辑内容</p>
              <!--              <p style="text-align: center" v-else-if="status === 2">请添加页面后编辑内容</p>-->
              <p style="text-align: center" v-else-if="status === 5">请在末级目录下编辑内容</p>
              <p v-else-if="status === 4">暂无内容,请<span style="cursor:pointer;color:#1890FF" @click="addShixun">添加实训</span></p>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   *  create by wjl at 2021.8.21
   *   新课程编辑模块
   */
  import newSidebar from "../component/new_sidebar";
  import addQuestion from "../component/addQuestion";
  import * as api from "../../api/courseApi";
  import * as sourceApi from "../../api/sourceApi";
  import bus from "../../bus/bus";
  import * as courseApi from "../../api/courseApi"; // 目录树
  import draggable from "vuedraggable"
  import { debounce } from "../../utils/utils";
  let _this;
  export default {
    name: "course_train_set",
    components: {
      newSidebar,
      addQuestion,
      draggable
    },
    data() {
      return {
        courseId: this.$route.query.courseId,
        subjectId: this.$route.query.subjectId,
        courseName: this.$route.query.courseName,
        subjectName: this.$route.query.subjectName,
        userName: sessionStorage.getItem('loginName'),
        zl_loading: false,
        catalogue: {}, // 选择的目录
        resources: [], // 目录下的资源
        selectResourse:[],//总选中数组
        presentList:[],//当前页码选中数组
        // status
        status: 0,
        selection: [],
        catalogName:'',
        checkCataObj:{},
        checkCataIndex:0,
        isParent:true,
        drag:true,
        beforePage: 0,
        showTrigonActive: false,
        courseModel: this.$route.query.courseModel, //课程模式 1标准 2产品
      };
    },
    created(){
      _this=this
    },
    mounted() {},
    methods: {
      handleSelectionChange(val){
        this.selection = val
      },
      deleteAll(){
        if(this.selection.length > 0){
          this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let params = {
                catalogId: this.catalogue.id,
                courseId: this.courseId,
                list: this.selection.map((val,ind)=>{
                  return val.courseResourceId
                }),
              };
              courseApi.batchDeleteSource(params).then((res) => {
                if (res.code == 0) {
                  this.handleTreeNodeClick(this.catalogue);
                  bus.$emit("businit");
                  this.$messageSuccess("删除成功");
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        }else{
          this.$message.warning("请选择题目");
        }
      },
      clearCatalogName(val){
        console.log(val)
        this.catalogName = val
      },
      emptyCatalogue() {
        this.status = 0;
      },
      handleTreeNodeClick(treeData, type) {
        console.log(treeData, type)
        if (treeData.catalogParentId == 0) {
          this.isParent = true;
          this.status = 0;
        return;
      }else if(treeData.children && treeData.children.length){
          return this.status = 5;
        } else
      //  console.log(!treeData.resourceBase,treeData.resourceBase.length == 0)
       this.isParent = false
        if (!treeData.resourceBase || treeData.resourceBase.length == 0) {
          if (type == "add") {
            this.catalogue = treeData;
            this.resources = []
            this.selectResourse = []
            this.presentList = []
            this.sectionName = "";
            this.status = 2;
            this.refresh = !this.refresh;
          }else{
            this.resources = []
            this.status = 4
            return
          }
      }else{
          this.zl_loading = true;
          this.catalogue = treeData;
          console.log(this.catalogue,'this.catalogue')
          api
            .handleNodeClick(this.courseId, JSON.parse(sessionStorage.getItem('new_sidebar_default')).id)
            .then((res) => {
              if (res.code == 0) {
                console.log(res)
                if (res.data && res.data.length) {
                  this.resources = res.data;
                  this.selectResourse = res.data
                  console.log('--2--', res.data )
                  if(type == 'add'){
                    this.status = 2;
                  }else{
                    this.status = 3;
                  }

                  this.getCheckInfo(0)
                } else {
                  this.resources = [];
                  this.sectionName = "";
                  this.status = 4;
                }

              } else {
                this.$message.warning("暂无数据");
              }
            })
            .finally(() => {
              this.zl_loading = false;
            })
            .catch((error) => {
              this.$messageError(error);
            });
        }
      },
      handleSaveTrain(){
        if (!this.selectResourse) {
          return this.$message.warning("请选择资源");
        }
        let resourcesID = this.resources.map((val,ind)=>{
          return val.id
        })
        let selectResourseID = this.selectResourse.map((val,ind)=>{
          return val.id
        })
        console.log(this.intersection(resourcesID,selectResourseID))
        console.log(this.difference(selectResourseID,this.intersection(resourcesID,selectResourseID)) )
        let newArrID = this.difference(selectResourseID,this.intersection(resourcesID,selectResourseID))
        let resource = {
          catalogId: JSON.parse(sessionStorage.getItem('new_sidebar_default')).id,
          courseId: this.courseId,
          list:this.selectResourse.map((val,ind)=>{
            let resourceName = ''
            if(val.name){
              resourceName = val.name
            }else if(val.taskName && val.taskName!=''){
              resourceName = val.taskName
            }else{
              if(val.questionContent && this.$delHtmlTag.delHtmlTag(val.questionContent).substring(0,100).length>=100){
                resourceName = val.questionContent?this.$delHtmlTag.delHtmlTag(val.questionContent).substring(0,100) + '...': ""
              }else{
                resourceName = val.questionContent ? this.$delHtmlTag.delHtmlTag(val.questionContent).substring(0,100) : ""
              }
            }

            let obj = {
              catalogId: JSON.parse(sessionStorage.getItem('new_sidebar_default')).id,
              courseId: this.courseId,
              resourceId: val.id,
              type: 3,
              tagName: '实操题',
              resourceName: resourceName,
              isNewAdd: 0
            }

            if(newArrID.length>0){
              if(newArrID.includes(val.id)){
                obj.isNewAdd = 1
              }
            }
            return obj
          }),
        };

        sourceApi.addQuestion(resource).then((res) => {
          bus.$emit("businit");
          if (res.code == 0) {
            this.handleTreeNodeClick(this.catalogue);
            this.$messageSuccess("添加成功");
          }else{
            this.$messageError(res.msg);
          }
        });
      },
      //交集
      intersection(arr1,arr2){
          let s1 = new Set(arr1)
          let s2 = new Set(arr2)
          //filter是数组的方法
          return [...s1].filter(item=>{
              return s2.has(item)   //判断s2中有没有和s1相同的元素
          })
      },
      //差集
      difference(arr1,arr2){
        let s1 = new Set(arr1)
        let s2 = new Set(arr2)
        return [...s1].filter(item=>{
            return !s2.has(item)   //此处与交集相反
        })
    },
      deleteRow(o){
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              catalogId: this.catalogue.id,
              courseId: this.courseId,
              list: [o.courseResourceId],
            };
            courseApi.batchDeleteSource(params).then((res) => {
              if (res.code == 0) {
                this.handleTreeNodeClick(this.catalogue);
                bus.$emit("businit");
                this.$messageSuccess("删除成功");
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
      edit(){
         api
            .handleNodeClick(this.courseId, JSON.parse(sessionStorage.getItem('new_sidebar_default')).id)
            .then((res) => {
              if (res.code == 0) {
                console.log(res)
                if (res.data && res.data.length) {
                  this.selectResourse = res.data
                  this.status = 2;
                  // this.getCheckInfo(0)
                } else {
                  this.resources = [];
                  this.sectionName = "";
                  this.status = 4;
                }

              } else {
                this.$message.warning("暂无数据");
              }
            })
            .finally(() => {
              this.zl_loading = false;
            })
            .catch((error) => {
              this.$messageError(error);
            });
        this.status = 2
      },
      setStatus(n) {
        // 初始化
        this.status = n;
        this.catalogue = {};
        this.resources = [];
      },
      openAddResoures(chapter, catalogue, from) {
        if (from === "add") {
          this.setStatus(2);
        } else {
          this.sectionName = catalogue.catalogName;
          this.status = 2;
        }
        this.addType = chapter.type;
        if (this.addType == 6 && chapter.imageText) {
          this.questionConfigure = chapter.imageText;
        }
        this.catalogue = catalogue;
      },
      selectChange:debounce((val)=>{
        _this.presentList = val
        _this.selectResourse = _this.unique(_this.selectResourse.concat(val))
        console.log(_this.selectResourse)
      },300,false),
      //去重
      unique(arr) {
        const res = new Map();
        return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
      },
      //拿到当页数据比对出勾选
      getQuestionList(list,type){
        console.log(list,this.selectResourse)
        let a=list;
        let b=this.selectResourse;
        let arr =  [] ;
        if(type == '交集'){
          a.forEach((val,ind)=>{
            b.forEach((val1,ind1)=>{
              if(val.id == val1.id){
                arr.push(val)
              }
            })
          })
        }else if(type == '并集'){
          // arr = Array.from(new Set([...a,...b]));
        }else if(type == '差集'){
          // arr = Array.from(new Set([...a].filter(x=>!b.has(x))));
        }
       console.log(arr)
       return arr
        // console.log(list,this.selectResourse)
        // this.presentList = arr
      },
      removeCheck(item,beforePage){
        if(item.length<=0){
          return
        }
        item.forEach((val,ind)=>{
          this.selectResourse = this.selectResourse.filter((val1)=>val1.id!=val.id)
        })
      },
      goback() {
        // this.$router.go(-1);
        this.$router.replace({
          // path: "/n-EditCourse",
          path: "/courseEditPage",
          query: {
            id: this.courseId,
            subjectId: this.subjectId,
            courseName: this.courseName,
            subjectName: this.subjectName,
            curId: 1,
            courseModel: this.courseModel,
          }
        })
      },
      showRow(row , index){
        this.checkCataObj = row
        this.checkCataIndex = index
        this.status = 3;
      },
       //evt里面有两个值，一个evt.added 和evt.removed  可以分别知道移动元素的ID和删除元素的ID
      change(evt) {
        console.log(evt.moved.oldIndex,evt.moved.newIndex,this.checkCataIndex, 'change...')
        if(evt.moved.oldIndex == this.checkCataIndex){
          this.checkCataIndex = evt.moved.newIndex
        }
      },
      //start ,end ,add,update, sort, remove 得到的都差不多
      start(evt) {
        this.drag = true
        console.log(evt , 'start...')
      },
      end(evt) {
        console.log(evt , 'end....')
        this.drag = true
        // evt.item //可以知道拖动的本身
        // evt.to    // 可以知道拖动的目标列表
        // evt.from  // 可以知道之前的列表
        // evt.oldIndex  // 可以知道拖动前的位置
        // evt.newIndex  // 可以知道拖动后的位置
        let params = {
          "catalogId": JSON.parse(sessionStorage.getItem('new_sidebar_default')).id,
          "courseId": this.courseId,
          "list":this.resources.map((val,ind)=>{
            let obj = {}
            obj.catalogId = JSON.parse(sessionStorage.getItem('new_sidebar_default')).id,
            obj.courseId = this.courseId
            obj.resourceId = val.id
            obj.sort = ind
            obj.type = val.resourceType
            obj.tagName = val.tagName
            return obj
          })
        }
        sourceApi.questionSort(params).then((res) => {
          if (res.code == 0) {
            this.$messageSuccess(res.msg);
          }else{
            this.$messageError(res.msg);
          }
        });
      },
      move(evt, originalEvent) {
        console.log(evt , 'move')
        console.log(originalEvent) //鼠标位置
      },
      getCheckInfo(index){
        this.checkCataIndex = index
        this.checkCataObj = this.resources[this.checkCataIndex]
      },
      addShixun(){
        if(!this.isParent){
          this.resources = []
          this.selectResourse = []
          this.presentList = []
          this.sectionName = "";
          this.status = 2;
          this.refresh = !this.refresh;
        }else{
          this.$messageError('主目录不可添加');
        }
      },
      handleCommand(command){
        if(command == 'd'){
          this.$logOut()
        }else if(command == 'a'){
          this.$router.push('/educa')
        }else if(command == 'b'){
          this.$router.push('/settings')
        }else if(command == 's'){
          this.$router.push('/dataStatistics')
        }
      },
      closeTag(item){
        this.removeCheck([item],'tag')
        this.$refs.addQuestion.initCheckList(item)
      }
    },
  };
</script>

<style scoped lang="scss">
  .course_train_set {
    width: 100%;
    height: 100%;
    min-width: 900px;
    overflow: hidden;
    // font-size: 13px;
    user-select: none;
    background: #F5F5F7;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    /*color: #ffffff;*/
    .course_train_set_head {
      padding: 0 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      background: #0E56AD;;
      .ct{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        display: flex;
        align-items: center;
      }
      .goback {
        font-size: 17px;
        cursor: pointer;
      }
      .zl-header-img {
        width: 40px;
        height: 40px;
        border-radius: 40px;
      }
    }
    .course_train_set_bottom {
      height: calc(100% - 50px);
      width: 1366px;
      margin: 0 auto;
      display: flex;
    }
    .course_train_set_tree {
      margin: 1% 0;
      width: 240px;
      background: #ffffff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 4px;
    }
    .course_train_set_content {
      width: calc(100% - 270px);
      flex: 1;
      margin: 1% 20px;
      background: #ffffff;
      border-radius: 4px;

      .add_resources_operation {
        height: 46px;
        line-height: 46px;
        background: rgba(24, 144, 255, 0.08);
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #42414D;
        // text-align: right;
        .catalog_name{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .course_train_set_2 {
        width: 96%;
        padding:0 2% 2% 2%;
        height: calc(96% - 120px);
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
      }
    .course_train_set_3{
      // padding:0 2% 2% 2%;
      height: calc(100% - 46px);
      position: relative;
      width: 100%;
      .tag_wrap{
        display: none;
        width:100%;
        height: 84px;
        min-height: 84px;
        padding:0px 2% 10px 2%;
        background: #FBFBFC;
        box-sizing: border-box;
        position: relative;
        // transition: 400ms;
        z-index: 9;
        /deep/ .el-tag {
          height: 27px;
          line-height: 25px;
          border-radius: 4px;
          border: 1px solid rgba(210, 210, 215, 0.5);
          background: #FFFFFF;
          margin-right: 10px;
          margin-top: 10px;
          color: rgba(15, 13, 17, 1);
          i{
            color: rgba(210, 210, 215, 1);
            &:hover{
              background: #fff;
            }
          }
        }
        .trigon{
          width: 18px;
          height: 6px;
          background: url(../../assets/image/sources/trigon1.png) no-repeat center/100%;
          position: absolute;
          right: 2%;
          bottom: -6px;
          cursor: pointer;
        }
      }
      .trigonActive{
        // transition: 400ms;
        // height: 400px;
        border-bottom: 1px solid #1890FF;
        height: auto!important;
        .trigon{
         background: url(../../assets/image/sources/trigon.png) no-repeat center/100%;
        }
      }
      .qst_wrap{
        position: absolute;
        width: 100%;
        // top: 90px;
        padding:0 2% 0 2%;
        height: 100%;
        box-sizing: border-box;
      }
    }
      /* 当状态为3，初始页面 */
      .course_train_set_0 {
        width: 100%;
        height: 100%;
        position: relative;
        .course_train_set_c {
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translate(-50%, -50%);
          img{
            width:187px;
            height:159px;
          }
          p {
            padding: 6px 0;
            font-size: 15px;
            color: #999999;
            text-align: center;
          }
        }
      }
    }
  }
  .course_train_set_2 /deep/ .cell{
    padding-left: 10px;
  }
  .course_train_set_2 /deep/ .has-gutter .cell{
    font-size: 12px;
    color: #767484;
    font-weight: 400;
  }
  /deep/ .el-table th>.cell{
    padding-left: 14px;
    padding-right: 14px;
  }
  .btn_wrap{
    height: 60px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    box-sizing: border-box;
  }
  .show_content{
    display:flex;
    height: 100%;
    .show_left{
      width:80%;
      .cont{
        padding:20px 100px 0 100px;
        box-sizing: border-box;
        height: calc(100% - 46px);
        /deep/ img{
          max-width: 100%;
        }
      }
    }
    .show_right{
      width: 20%;
      box-sizing: border-box;
      background: #FFFFFF;
      box-shadow: -5px 0px 10px 0px rgba(183, 192, 199, 0.14);
      border-radius: 0px 4px 4px 4px;
      .show_title{
        height: 46px;
        padding: 0 8px;
        font-size: 12px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #D2D2D7;
        box-sizing: border-box;
      }
      .syllable_ul{
        padding-bottom: 20px;
        box-sizing: border-box;
        height: calc(100% - 60px);
        overflow-y: scroll;
        &::-webkit-scrollbar { width: 0 !important }
        li{
          position: relative;
          margin: 0 10px;
          box-sizing: border-box;
          // width:100%;
          height: 74px;
          box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 0.53);
          border-radius: 4px;
          padding: 13px 9px;
          box-sizing: border-box;
          margin-top: 12px;
          // transition: transform 0.25s ease;
          .title{
            font-size: 12px;
            margin-bottom: 4px;
            font-weight: 500;
          }
          /deep/ .cont{
            line-height: 20px;
            height: 40px;
            overflow: auto;
            text-overflow: ellipsis;
            display: -webkit-box;
            font-size: 12px;
            color: #42414D;
            img{
              display: none;
            }
          }
          /*/deep/ .cont *{*/
          /*  font-size: 12px!important;*/
          /*  color: #42414D!important;*/
          /*  font-weight: 400!important;*/
          /*  font-style: inherit!important;*/
          /*  text-decoration: inherit!important;*/
          /*}*/
          border: 1px solid #F5F5F7;
          .syllable_img{
            position: absolute;
            width: 14px;
            height: 14px;
            top: 4px;
            right: 4px;
            // background: url(../../../src/assets/image/sources/jvxing.png)no-repeat center/100%;
          }
          &:hover{
            transition: 400ms;
            transform: scale(1.1);
            border: 1px solid rgba(24, 144, 255, 0.5)!important;
            .syllable_img{
              // background: url(../../../src/assets/image/sources/jvxing.png)no-repeat center/100%;
            }
          }
        }
        .active{
          background: rgba(24, 144, 255, 0.05);
          border: 1px solid rgba(24, 144, 255, 0.3);
          .title{
            color: rgba(24, 144, 255, 1);
          }
        }
      }
    }
  }
   .login-user {
      position: relative;
      cursor: pointer;
      .login-name {
        margin-left: 6px;
        color: #fff;
        line-height: 20px;
        font-size: 12px;
      }
      .user-name {
        height: 40px;
        display: flex;
        align-items: center;
        .imgBox {
          width: 18px;
          height: 18px;
          text-align: center;
          line-height: 18px;
          border: 1px solid #333;
          border-radius: 50%;
          img{
            height: 100%;
          }
        }
      }
      .el-dropdown {
        margin-right: 32px;
      }
      &:hover{
        .login-name {
          opacity: 0.8;
        }
      }
    }
    /deep/ .question_title{
      height: 46px;
      line-height: 46px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      img{
        display: none;
      }
    }
    /deep/ .question_title *{
      font-size: 12px!important;
      color: #262628!important;
      font-weight: 400!important;
      font-style: inherit!important;
      text-decoration: inherit!important;
    }
    .cont_inner{
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      counter-reset: list-0;
      line-height: 1.42;
       height: calc(100% - 50px);
      outline: none;
      overflow-y: auto;
      padding: 12px 15px;
      tab-size: 4;
      -moz-tab-size: 4;
      text-align: left;
      white-space: pre-wrap;
      word-wrap: break-word;
      color: #42414D;
    }
</style>



// WEBPACK FOOTER //
// src/views/course_train_set/index.vue